import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IacRepositoryField, IacSecretWiringField, IacValueField, IacValueNameField, validateIacValueName } from './IacFields';

/** Campos `ui:field: IacRepositoryField`, `IacValueNameField`, `IacSecretWiringField` e `IacValueField` de la plantilla "Cambiar una variable o secreto de IaC". */
export const IacRepositoryFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({ name: 'IacRepositoryField', component: IacRepositoryField }),
);

export const IacValueNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({ name: 'IacValueNameField', component: IacValueNameField, validation: validateIacValueName }),
);

export const IacValueFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({ name: 'IacValueField', component: IacValueField }),
);

export const IacSecretWiringFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({ name: 'IacSecretWiringField', component: IacSecretWiringField }),
);
